/*
 * suppression lot
 */
$(document).on('click', '[name="action"][value="contactdelete"][data-contactdelete][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		data: { action: 'contactdelete', contactdelete: $this.data('contactdelete') },
		dataType: 'json'
	}).done(function(data) {
		if( data.success ) {
			$.fancybox.close();
			$('#contact_' + $this.data('contactdelete')).fadeOut();
			var str = '<div id="pp_' + random_str + '" class="toast" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body alert alert-success mb-0">Contact supprimé</div></div>';
			$('#toasts_container').append(str);
			$('#toasts_container #pp_' + random_str).toast({ autohide: true, delay: 1000 }).toast('show');
			$('#toasts_container #pp_' + random_str).on('hidden.bs.toast', function () {
				$(this).remove();
			});
		}
		else if( data.error != '') {
			var random_str = Math.floor((Math.random() * 100000000) + 1).toString();
			var str = '<div id="pp_' + random_str + '" class="toast" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body alert alert-danger mb-0">' + data.error + '</div></div>';
			$('#toasts_container').append(str);
			$('#toasts_container #pp_' + random_str).toast({ autohide: true, delay: 1000 }).toast('show');
			$('#toasts_container #pp_' + random_str).on('hidden.bs.toast', function () {
				$(this).remove();
			});
		}
	});
});

$(document).on('click', '[name="action"][value="doublondelete"][data-doublondelete][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		data: { action: 'doublondelete', doublondelete: $this.data('doublondelete') },
		dataType: 'json'
	}).done(function(data) {
		if( data.success ) {
			$.fancybox.close();
			$('#doublon_' + $this.data('doublondelete')).fadeOut();
			var str = '<div id="pp_' + random_str + '" class="toast" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body alert alert-success mb-0">Doublon supprimé</div></div>';
			$('#toasts_container').append(str);
			$('#toasts_container #pp_' + random_str).toast({ autohide: true, delay: 1000 }).toast('show');
			$('#toasts_container #pp_' + random_str).on('hidden.bs.toast', function () {
				$(this).remove();
			});
			$('#frm_dashboard_admin_doublons_label .badge').html( parseInt($('#frm_dashboard_admin_doublons_label .badge').text()) - 1 );
		}
		else if( data.error != '') {
			var random_str = Math.floor((Math.random() * 100000000) + 1).toString();
			var str = '<div id="pp_' + random_str + '" class="toast" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body alert alert-danger mb-0">' + data.error + '</div></div>';
			$('#toasts_container').append(str);
			$('#toasts_container #pp_' + random_str).toast({ autohide: true, delay: 1000 }).toast('show');
			$('#toasts_container #pp_' + random_str).on('hidden.bs.toast', function () {
				$(this).remove();
			});
		}
	});
});

$(document).on('click', '[name="action"][value="relancetraite"][data-relancetraite][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		data: { action: 'relancetraite', relancetraite: $this.data('relancetraite') },
		dataType: 'json'
	}).done(function(data) {
		$('#relance_' + $this.data('relancetraite')).fadeOut();
	});
});

$(document).on('click', '[name="action"][value="relancedelete"][data-relancedelete][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		data: { action: 'relancedelete', relancedelete: $this.data('relancedelete') },
		dataType: 'json'
	}).done(function(data) {
		$('#relance_' + $this.data('relancedelete')).fadeOut();
	});
});

if( sessionStorage.dashboard_tab ) {
	$('#' + sessionStorage.dashboard_tab).tab('show');
}
else {
	$('#dashboard a[data-toggle="pill"]:eq(0)').tab('show');
}

$('#dashboard a[data-toggle="pill"]').on('show.bs.tab', function(e) {
	sessionStorage.setItem('dashboard_tab', $(e.target).attr('id'));
});
